import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { User } from '../models/user.model';
import { SidebarService } from '../services/side-bar.service';
import { TaskBarService } from '../services/task-bar.service';
import { FabMessageService } from '../services/fab-message.service';
import { NavigationEnd, Router } from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';
import { HeaderService } from '../services/header.service';
import { NotificationsService } from '../services/notifications.service';
import { OperatingStandardComponent } from '../content-page/operating-standard/operating-standard.component';
import { UserConfirmStandardComponent } from '../content-page/operating-standard/user-confirm-standard/user-confirm-standard.component';
import { UserFamiliarizeStandardComponent } from '../content-page/operating-standard/user-familiarize-standard/user-familiarize-standard.component';
import { AdminService } from '../services/admin.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportDatepickerComponent } from '../modals/report-datepicker.component';
import { ReportType } from '../models/report-type.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  public user: User;
  public showSideTasks = true;
  mainGroup;
  isAdmin = false;
	isUser = false;
	isHead = false;
  isHeadOfGroup = false;
  group;
  current;
  planned;
  allHeadGroups;
  mobWidth: any;

  constructor(public authService: AuthService,
    private modalService: NgbModal,
    private adminService: AdminService,
    public userService: UserService,
    public sidebarService: SidebarService,
    public operatingStandardComponent: OperatingStandardComponent,
    public taskbarService: TaskBarService,
    public fabService: FabMessageService,
    public notificationsService: NotificationsService,
    public headerService: HeaderService,
    private userConfirmStandardComponent: UserConfirmStandardComponent,
    private userFamiliarizeStandardComponent: UserFamiliarizeStandardComponent,
    private router: Router) {


    this.router.events.filter(event => event instanceof NavigationEnd)
      .pairwise().subscribe((value: [NavigationEnd, NavigationEnd]) => {
        if (value[1].url === '/dashboard/home' || value[1].url === '/dashboard') {
          this.showSideTasks = false;
          this.taskbarService.closeTaskBar();
          this.sidebarService.setSelectedMenuOption('home');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else {
          this.showSideTasks = true;
          this.taskbarService.setTaskBar((localStorage.getItem('TaskBar') === 'true'));
        }

        if (value[1].url === '/dashboard/company-structure-user') {
          this.sidebarService.setSelectedMenuOption('m-groups');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(true);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/operating-standard') {
          this.sidebarService.setSelectedMenuOption('op-stands');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/my-created-standards') {
          this.sidebarService.setSelectedMenuOption('my-created-standards');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/standards') {
          this.sidebarService.setSelectedMenuOption('m-stands');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        } else if (value[1].url === '/dashboard/standards') {
          this.sidebarService.setSelectedMenuOption('m-standss');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        }
        else if (value[1].url === '/dashboard/admin/all-standards-head-only') {
          this.sidebarService.setSelectedMenuOption('m-stands-sho');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        } else if (value[1].url === '/dashboard/report') {
          this.sidebarService.setSelectedMenuOption('m-report');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/company-structure') {
          this.sidebarService.setSelectedMenuOption('comp-str');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/admin/users') {
          this.sidebarService.setSelectedMenuOption('users');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(true);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/admin/register-user') {
          this.sidebarService.setSelectedMenuOption('register-user');
          this.sidebarService.setSelectedGroupOptionControll(true);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/admin/create-group') {
          this.sidebarService.setSelectedMenuOption('crt-division');
          this.sidebarService.setSelectedGroupOptionControll(true);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/admin/create-position') {
          this.sidebarService.setSelectedMenuOption('add-pos');
          this.sidebarService.setSelectedGroupOptionControll(true);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/admin/create-schedule') {
          this.sidebarService.setSelectedMenuOption('add-sched');
          this.sidebarService.setSelectedGroupOptionControll(true);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);

        } else if (value[1].url === '/dashboard/admin/create-standard') {
          this.sidebarService.setSelectedMenuOption('create-stnd');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(true);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/admin/all-standards') {
          this.sidebarService.setSelectedMenuOption('all-stnd');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(true);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
         } else if (value[1].url === '/dashboard/admin/standards-management-admin') {
          this.sidebarService.setSelectedMenuOption('all-stnd-ad');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(true);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/admin/all-standards-head') {
          this.sidebarService.setSelectedMenuOption('all-stnds');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        } else if (value[1].url === '/dashboard/create-operating-standard') {
          this.sidebarService.setSelectedMenuOption('create-opstnd');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        } else if (value[1].url === '/dashboard/operating-standards') {
          this.sidebarService.setSelectedMenuOption('all-opstnd');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(true);
        } else if (value[1].url === '/dashboard/standards-management') {
          this.sidebarService.setSelectedMenuOption('std-mngmnt');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
          this.sidebarService.setSelectedStandardsManagement(true);


          // SUGGESTION LISTS
        } else if (value[1].url === '/dashboard/create-suggestion-list') {
          this.sidebarService.setSelectedMenuOption('create-sl');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(true);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/my-suggestion-lists') {
          this.sidebarService.setSelectedMenuOption('my-sl');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/my-suggestion-list') {
          this.sidebarService.setSelectedMenuOption('my-sl-m');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/all-suggestion-lists') {
          this.sidebarService.setSelectedMenuOption('all-sl');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(true);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        } else if (value[1].url === '/dashboard/for-review-suggestion-lists') {
          this.sidebarService.setSelectedMenuOption('for-review-sl');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(true);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        }

        // Specializations
        else if (value[1].url === '/dashboard/specializations-list') {
          this.sidebarService.setSelectedMenuOption('spec-list');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        }

        // Learning
        else if (value[1].url === '/dashboard/learning') {
          this.sidebarService.setSelectedMenuOption('learning');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        }

        else if (value[1].url === '/dashboard/general-settings') {
          this.sidebarService.setSelectedMenuOption('learniy');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        }

        else if (value[1].url === '/dashboard/calendar') {
          this.sidebarService.setSelectedMenuOption('learnit');
          this.sidebarService.setSelectedGroupOptionControll(false);
          this.sidebarService.setSelectedGroupOptionStandards(false);
          this.sidebarService.setSelectedSL(false);
          this.sidebarService.setSelectedGroupOptionOpStandards(false);
        }

      });

  }

  @Output() featureSelected = new EventEmitter<string>();

  ngOnInit() {

    this.getList(JSON.parse(localStorage.getItem('User')).mainGroup);

    this.mainGroup = JSON.parse(localStorage.getItem('User')).mainGroup;

    this.user = this.userService.getLocal();

    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
      this.getAllGroups();
    } else {
      this.isHead = false;
    }
    if (this.user.roles.indexOf('ROLE_USER') !== -1) {
      this.isUser = true;
    } else {
      this.isUser = false;
    }

   
    if (this.router.url === '/dashboard') {
      this.showSideTasks = false;
      this.taskbarService.closeTaskBar();
      this.sidebarService.setSelectedMenuOption('home');
      this.sidebarService.setSelectedGroupOptionControll(false);
      this.sidebarService.setSelectedGroupOptionStandards(false);
    }
    this.sidebarService.setSideBar(localStorage.getItem('NavBar') === 'true');
    this.taskbarService.setTaskBar(localStorage.getItem('TaskBar') === 'true');
  }

  getShift() {
    this.adminService.getsUsersShift().subscribe(
      (response: any) => {
        let a = response.body;
      if (a.current) {
        this.current = a.current;
      }
      if(a.planned) {
          this.planned = a.planned;
      }
    },
    (error: any) => {
  
      }
    )
  }


  open(id) {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_VACATION;
		modalRef.componentInstance.userId = id;
	  }

  getList(a) {
		this.adminService.getGroupByID(a).subscribe(
			(response: any) => {
					this.group = response.body;
          this.getShift();
					if (this.group.head != null) {
						if (this.group.head.id === JSON.parse(localStorage.getItem('User')).id) {
							this.isHeadOfGroup = true;
						}
					}
			},
		);
	}


  signOut() {
    this.userService.writeLogoutTime().subscribe(
      (response: any) => {
        this.fabService.showFab(1);
        this.userService.deleteLocal();
        this.authService.signOut();
      },
      (error: any) => {
        if (error.status === 400) {
          this.fabService.showFab(2);
          this.userService.deleteLocal();
          this.authService.signOut();
        }
      }
    );
  }

  onSidebar() {
    this.sidebarService.openSideBar();
  }

  onTaskbar() {
    if (!this.userService.getLocal().testing) {
      this.taskbarService.openTaskBar();
    }
  }

  isTesting() {
    return this.userService.getLocal().testing;
  }

  recordSignOutTime() {
    this.userService.writeLogoutTime().subscribe(
      (response: any) => {
        this.fabService.showFab(1);
      },
      (error: any) => {
        if (error.status === 400) {
          this.fabService.showFab(2);
        }
      }
    );

  }

  disableLogout(): boolean {
    return this.userService.getLocal().testing;
  }

  onNotifyHeader() {
    if (this.userService.getLocal() !== null) {
      if (!this.userService.getLocal().testing) {
        const notify = this.notificationsService.getNearNotification();
        // this.operatingStandardComponent.openNotification(notify.standardId, notify.type, notify.status);
        this.operatingStandardComponent.openNotification(notify);
      }
    }

  }

  getAllGroups() {
    this.adminService.getGroupsAndPositionsHead().subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.allHeadGroups = res.body;
        }
      }
    )
  }
}








// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/header/header.component.ts